import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import LoanInventoryModule from './LoanInventoryModule';
import LoanInModule from './LoanInModule';
import LoanOutModule from './LoanOutModule';
import LoanApprovalsModule from './LoanApprovalsModule';

const LoanItemsModule = () => {
  const location = useLocation();
  const [tabValue, setTabValue] = useState(0);
  const [linkState, setLinkState] = useState({ recordId: null, recordType: null });

  useLayoutEffect(() => {
    const t = location.state?.loanTab;
    if (typeof t === 'number') {
      setTabValue(t);
    }
  }, [location.state?.loanTab]);

  useEffect(() => {
    const state = location.state;
    setLinkState({ recordId: state?.recordId || null, recordType: state?.recordType || null });
  }, [location.state]);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Loan Items
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Standalone loan module: loan-out with AM approvals; loan-in is submitted into Store Receiving (main store inventory) using a loan reference instead of a PO.
      </Typography>
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Loan Inventory" />
          <Tab label="Loan In" />
          <Tab label="Loan Out" />
          <Tab label="Loan Approvals" />
        </Tabs>
      </Paper>

      {tabValue === 0 && <LoanInventoryModule />}
      {tabValue === 1 && <LoanInModule />}
      {tabValue === 2 && <LoanOutModule />}
      {tabValue === 3 && <LoanApprovalsModule />}
    </Box>
  );
};

export default LoanItemsModule;
